import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { addDealerType, addExcludeTestDealers } from '../analyticsQuery'
import { IChatQuestionReport, IQuestionReportParams } from '../models'

/** Bayilerin sorduğu sorular (ADR-021): `source` boşsa yazılan + buton turlarının hepsi gelir. */
export class GetQuestionReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/chatbot-analytics/questions', requesterInfo })
  }

  public async getReport(params: IQuestionReportParams): Promise<IChatQuestionReport> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', params.fromUtc.toISOString())
    query.add('toUtc', params.toUtc.toISOString())
    if (params.source) query.add('source', params.source)
    if (params.search) query.add('search', params.search)
    if (params.text) query.add('text', params.text)
    if (params.intent) query.add('intent', params.intent)
    if (params.outcome) query.add('outcome', params.outcome)
    if (params.vote) query.add('vote', params.vote)
    query.add('page', String(params.page))
    query.add('pageSize', String(params.pageSize))
    query.add('export', String(params.export))
    addExcludeTestDealers(query, params.excludeTestDealers)
    addDealerType(query, params.dealerType)
    this.queryParams = query
    return await this.getAsync<IChatQuestionReport>()
  }
}
